import { Requester } from './Requester';
import { IUserDocumentPopulated } from '../types';

// ALL PLACEHOLDER
export const PatchUser = async ({
    userId,
    name,
    email,
    role,
    preferredLang,
    isAdmin
}: {
    userId: string;
    name?: string;
    email?: string;
    role?: string;
    preferredLang?: string;
    isAdmin?: boolean;
}): Promise<IUserDocumentPopulated | null> => {
    const updatePayload: { name?: string; email?: string; role?: string; preferredLang?: string } = {};

    if (name) {
        updatePayload.name = name;
    }
    if (email) {
        updatePayload.email = (email ?? '').trim();
    }
    if (role) {
        updatePayload.role = role;
    }
    if (preferredLang) {
        updatePayload.preferredLang = preferredLang;
    }

    try {
        const response = await Requester<{ user: IUserDocumentPopulated | boolean } | null>({
            path: isAdmin ? `users/admin/${userId}` : `users/${userId}`,
            method: 'PATCH',
            payload: updatePayload
        });
        console.log('patched user', response);
        return response && 'user' in response && response.user !== false
            ? (response.user as IUserDocumentPopulated)
            : null;
    } catch (e) {
        console.error('Patch user request failed');
        return Promise.reject(e);
    }
};
